import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_BACKEND_PROXY_URL || import.meta.env.VITE_BACKEND_URL || 'http://localhost:5000';

/**
 * Dashboard API Service - Frontend service for fetching dashboard data
 */
class DashboardApiService {
  
  /**
   * Get hero metrics
   */
  async getHeroMetrics(restaurantId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/dashboard/metrics/${restaurantId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching hero metrics:', error);
      throw error;
    }
  }

  /**
   * Get revenue analytics
   * @param {string} period - 'today' | 'week' | 'month' | 'monthly_comparison'
   */
  async getRevenueAnalytics(restaurantId, period = 'week') {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/revenue/${restaurantId}?period=${period}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching revenue analytics:', error);
      throw error;
    }
  }

  /**
   * Get orders overview
   */
  async getOrdersOverview(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/orders/overview/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching orders overview:', error);
      throw error;
    }
  }

  /**
   * Get recent orders
   */
  async getRecentOrders(restaurantId, limit = 20) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/orders/recent/${restaurantId}?limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching recent orders:', error);
      throw error;
    }
  }

  /**
   * Get top menu items
   */
  async getTopMenuItems(restaurantId, days = 7, limit = 10) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/menu/top-items/${restaurantId}?days=${days}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching top menu items:', error);
      throw error;
    }
  }

  /**
   * Get staff performance
   */
  async getStaffPerformance(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/staff/performance/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching staff performance:', error);
      throw error;
    }
  }

  /**
   * Get payment analytics
   */
  async getPaymentAnalytics(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/payments/analytics/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching payment analytics:', error);
      throw error;
    }
  }

  /**
   * Get table status
   */
  async getTableStatus(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/tables/status/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching table status:', error);
      throw error;
    }
  }

  /**
   * Get customer insights
   */
  async getCustomerInsights(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/customers/insights/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching customer insights:', error);
      throw error;
    }
  }

  /**
   * Get all dashboard data in one call (optimized)
   */
  async getAllDashboardData(restaurantId) {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/dashboard/all/${restaurantId}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching all dashboard data:', error);
      throw error;
    }
  }
}

export default new DashboardApiService();
